import { useCallback, useState } from 'react';

export function useCreationFeedback() {
  const [error, setError] = useState<string>();
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
  const clearFields = useCallback((...fields: string[]) => {
    setFieldErrors(previous => ({
      ...previous,
      ...Object.fromEntries(fields.map(field => [field, ''])),
    }));
  }, []);
  const reset = () => {
    setError(undefined);
    setFieldErrors({});
  };
  return { error, setError, fieldErrors, setFieldErrors, clearFields, reset };
}
